<template>
<div class="divSelectOptions">
    <h4 class="titre">Options incluses<i v-if="!noEmojis" class="em em-star-struck" aria-role="presentation" aria-label="GRINNING FACE WITH STAR EYES"></i></h4>
    <template v-if="listOptions.length">
        <div class="listOptions included">
            <template v-for="(option, index) in listOptions">
                <div :key="index" class="option" :id="'option_'+option.id" v-if="option.included && JSON.stringify(option.booth).includes(booth.id)">
                    <div class="contentOpt" @click="selectOption(option)">
                        <img :id="'check_'+option.id" class="check_included" alt="option selected" src="https://preprod.api.defipix.fr/ressource/reservation/image/check-circle.png" />
                        <div class="nameContainer">
                            <h5 class="nameOpt">{{ option.name }}</h5>
                        </div>
                        <img class="illusOpt" :src="'https://preprod.api.defipix.fr/ressource/reservation/image/'+option.picture">
                        <p class="descOpt">{{ option.description }}</p>
                    </div>
                    <div class="actionOpt">
                        <h5 v-if="$store.getters.reservation_client.client.typeClient === 'Particulier'" class="price crossed">{{ option.price }}€</h5>
                        <h5 v-else-if="$store.getters.reservation_client.client.typeClient === 'Professionnel'" class="price crossed">{{ (Number(option.price)-Number(option.price/5)).toFixed(2) }}€ HT</h5>
                        <h4 class="gift">Offert</h4>
                        <img :id="'info_'+option.id" @click="openOpt(option.id)" class="infoBtn" alt="get more infos about this option" src="https://preprod.api.defipix.fr/ressource/reservation/image/info2.png" />
                    </div>
                </div>
            </template>
        </div>
        <div class="optComp">
            <h4 class="titre">Options complémentaires</h4>
            <div class="listOptions">
                <template v-for="(option, index) in listOptions">
                    <div :key="index" class="option clickable" :id="'option_'+option.id" v-if="!option.included && JSON.stringify(option.booth).includes(booth.id)">
                        <div class="contentOpt" @click="selectOption(option)">
                            <div class="nameContainer">
                                <h5 class="nameOpt">{{ option.name }}</h5>
                            </div>
                            <img class="illusOpt" :src="'https://preprod.api.defipix.fr/ressource/reservation/image/'+option.picture">
                            <p class="descOpt">{{ option.description }}</p>
                        </div>
                        <div class="actionOpt">
                            <span @click="selectOption(option)" v-if="option.price && $store.getters.reservation_client.client.typeClient === 'Particulier'" class="price">{{ option.price }}€</span>
                            <span @click="selectOption(option)" v-if="option.price && $store.getters.reservation_client.client.typeClient === 'Professionnel'" class="price">{{(Number(option.price)-Number(option.price/5)).toFixed(2) }}€ HT</span>
                            <select type="text" :name="'selectOpt_'+option.id" :id="'selectOpt_'+option.id" v-if="option.option_select" @change="selectOption(option)">
                                <template v-for="(optionSelect, index) in option.option_select">
                                    <option v-if="$store.getters.reservation_client.client.typeClient === 'Particulier'" :key="index" :value="optionSelect.label+'|'+optionSelect.price">{{ optionSelect.label }} ({{ optionSelect.price }}€)</option>
                                    <option v-else-if="$store.getters.reservation_client.client.typeClient === 'Professionnel'" :key="index" :value="optionSelect.label+'|'+optionSelect.price">{{ optionSelect.label }} ({{ (Number(optionSelect.price)-Number(optionSelect.price/5)).toFixed(2) }}€ HT)</option>
                                </template>
                            </select>
                            <img :id="'info_'+option.id" @click="openOpt(option.id)" class="infoBtn" alt="get more infos about this option" src="https://preprod.api.defipix.fr/ressource/reservation/image/info2.png" />
                            <img :id="'add_'+option.id" @click="selectOption(option)" class="add" alt="add this option" src="https://preprod.api.defipix.fr/logos/add_200.png" />
                            <img :id="'trash_'+option.id" @click="deleteOption(option)" class="trash" alt="delete this option" src="https://preprod.api.defipix.fr/logos/trash_200.png" />
                        </div>
                        <div class="patch">
                            <img v-if="option.best_seller" class="bestSeller" alt="option best seller" src="https://preprod.api.defipix.fr/logos/best_seller200.png" />
                            <img :id="'check_'+option.id" class="check" alt="option selected" src="https://preprod.api.defipix.fr/ressource/reservation/image/check-circle-blue.png" />
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </template>
    <div v-else id="loader">
        <h4>Chargement</h4>
        <img src="https://preprod.api.defipix.fr/ressource/reservation/image/loader.gif" />
    </div>
    <NavBar :next="true" :prev="true" />
</div>
</template>

<script>
import NavBar from '@/components/OrderBooth/NavBar'
import axios from 'axios'
import JQuery from 'jquery'
let $ = JQuery

export default {
    data() {
        return {
            listOptions: [],
            booth: this.$store.getters.reservation_client.borne,
            noEmojis: this.$store.getters.reservation_client.noEmojis,
        }
    },
    mounted: function () {
        $('html,body').animate({scrollTop: 0}, 'slow');
        this.getListOptions()
    },
    updated: function () {
        // $("select").val("");
        for (let option of this.$store.getters.reservation_client.optionSelected) {
            $("#option_" + option.id).addClass("selectedOPT");
            // $("#selectOpt_" + option.id).prop("disabled", true);
            $("#check_" + option.id).show();
            $("#trash_" + option.id).show();
            $("#add_" + option.id).hide();
            if (option.select) {
                $("#selectOpt_" + option.id).val(`${option.select.label}|${option.select.price}`);
            }
        }
    },
    methods: {
        async getListOptions() {
            try {
                const response = await axios.get('https://preprod.api.defipix.fr/option');
                response.data.sort(function(a,b) {
                    a.sort_id == 0 ? a.sort_id = 999 : a.sort_id;
                    a.sort_id == null ? a.sort_id == 999 : a.sort_id;
                    b.sort_id == 0 ? b.sort_id = 1000 : b.sort_id;
                    b.sort_id == null ? b.sort_id == 1000 : b.sort_id;
                    return a.sort_id - b.sort_id;
                });
                this.listOptions = response.data;
            } catch (error) {
                console.error(error);
            }
        },
        selectOption(option) {
            let present = false;
            this.$store.getters.reservation_client.optionSelected.forEach(element => {
                if (element.id == option.id) {
                    present = element;
                }
            });
            if (present) {
                if(!option.price && $("#selectOpt_" + option.id).val() && present.select.price != $("#selectOpt_" + option.id).val().split("|")[1]) {
                     option.option_select.forEach(element => {
                        let optSelected = $("#selectOpt_" + option.id).val().split("|")
                        if (element.label === optSelected[0] && Number(element.price) === Number(optSelected[1])) {
                            option.select = element;
                        }
                    });
                    this.$store.commit('RCrmOption', option.id);
                    delete option.long_description;
                    delete option.description;
                    delete option.booth;
                    delete option.createdAt;
                    delete option.updatedAt;
                    delete option.included;
                    delete option.best_seller;
                    delete option.imageArray;
                    this.$store.commit('RCaddOption', option);
                } else {
                    this.deleteOption(option);
                }
            } else {
                if (!option.price && !$("#selectOpt_" + option.id).val()) {
                    $("#selectOpt_" + option.id).val($(`#selectOpt_${option.id} option:first`).val());
                }
                if (!option.price) {
                    option.option_select.forEach(element => {
                        let optSelected = $("#selectOpt_" + option.id).val().split("|")
                        if (element.label === optSelected[0] && Number(element.price) === Number(optSelected[1])) {
                            option.select = element;
                        }
                    });
                }
                delete option.long_description;
                delete option.description;
                delete option.booth;
                delete option.createdAt;
                delete option.updatedAt;
                delete option.included;
                delete option.best_seller;
                delete option.imageArray;
                this.$store.commit('RCaddOption', option);
                // $("#selectOpt_" + option.id).prop("disabled", true);
                $("#check_" + option.id).show();
                $("#trash_" + option.id).show();
                $("#add_" + option.id).hide();
                $("#option_" + option.id).addClass("selectedOPT");
            }
        },
        deleteOption(option) {
            this.$store.commit('RCrmOption', option.id);
            // $("#selectOpt_" + option.id).prop("disabled", false);
            $("#selectOpt_" + option.id).val(" ");
            $("#check_" + option.id).hide();
            $("#trash_" + option.id).hide();
            $("#add_" + option.id).show();
            $("#option_" + option.id).removeClass("selectedOPT");
        },
        openOpt(id) {
            window.open(`./#/Options?reservation=true&id=${id}&booth=${this.booth.id}`);
            window.focus();
        },
        nextStep() {
            //Nothing to do
        }
    },
    components: {
        NavBar
    }
}
</script>

<style scoped>
.divSelectOptions {
    margin-bottom: 2em;
    background-color: rgb(248, 248, 248);
    border-radius: 10px;
    padding-top: 2em;
    background-color: #25327B;
    box-shadow: 0px 0px 5px 0px #aaa;
}

.listOptions {
    display: grid;
    grid-template-columns: auto auto auto;
    grid-gap: 2em;
    margin: auto auto 1em auto;
    width: fit-content;
}


.optComp {
    background-color: #f677c4;
    padding: 2em;
    border-radius: 10px;
    margin: 3em auto;
    width: fit-content;
}

.included {
    background-color: unset;
}

.selectedOPT {
    box-shadow: 0px 0px 5px 0px #25327B;
}

.nameContainer {
    display: flex;
    align-items: center;
}

.nameOpt {
    grid-area: title;
    color: #25327B;
}

h5, .price {
    color: #25327B;
}

.descOpt {
    grid-area: description;
    min-height: 3em;
    font-size: 15px;
}

select, option {
    width: 75%;
    border-radius: 5px;
    height:  2em;
    padding: 5px;
    font-weight: 200;
    border: 1px solid #f677c4;
    background-color: rgb(248, 248, 248);
}

.price {
    width: 75%;
    font-size: 18px;
}

.titre {
    color: #fff;
}

.option {
    display: flex;
    flex-direction: column;
    margin: auto;
    width: 22em;
    background-color: #eeeeee;
    border-radius: 8px;
    position: relative;
    box-shadow: 2px 2px 2px 0px #666;
}

.clickable:hover {
    cursor: pointer;
}

.contentOpt {
    height: 10em;
    display: grid;
    grid-template-areas:
        'illustration title'
        'description description';
        grid-template-columns: 25% 75%;
    /* justify-content: space-between; */
    padding: .75em;
}

.actionOpt {
    padding: .75em;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.infoBtn {
    width: 2em;
}

.illusOpt {
    grid-area: illustration;
    width: 5em;
    padding: 0.5em;
    margin: auto;
    margin-bottom: 1em;
}

.patch {
    position: absolute;
    top: -1em;
    right: -1em;
}

.check {
    display: none;
}

.bestSeller, .check, .check_included {
    width: 3em;
}

.check_included {
    position: absolute;
    top: -1em;
    right: -1em;
}

.crossed {
    text-decoration: line-through;
    text-decoration-color: #25327B;
}

.gift {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    text-align: center;
    color: #f677c4;
    width: fit-content;
    margin: .5em auto;
}

.trash, .add {
    width: 1.7em;
    height: 1.7em;
}

.trash {
    display: none;
}

.trash:hover, .add:hover, .infoBtn:hover {
    cursor: pointer;
    transform: scale(1.1);
}

#loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2em 5em;
    background-color: #f677c4;
    width: fit-content;
    margin: 5em auto;
    border-radius: 10px;
    justify-content: center;
    color: #fff;
}

@media only screen and (max-width: 1350px) {
    .listOptions {
        grid-template-columns: auto auto;
    }
}

@media only screen and (max-width: 925px) {
    .listOptions {
        grid-template-columns: auto auto;
    }

    .option {
        width: 18.5em;
    }
}

@media only screen and (max-width: 767px) {
    .listOptions {
        grid-template-columns: auto;
    }

    .illusOpt {
        width: 4em;
    }

    .check_included, .check, .bestSeller {
        width: 2.5em;
    }
}

@media only screen and (max-width: 510px) {
    .optComp {
        padding: 2em 0;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/OrderBooth/Options.vue